import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { requestAdminPasswordReset } from '../services/adminPasswordResetApi';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import '../styles/adminLoginPage.css';

const AdminForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await requestAdminPasswordReset({ email });
      setSuccess(true);
      setEmail('');
    } catch (err) {
      const message = err?.message || err?.details || 'Failed to send reset link. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminLogin">
      <div className="adminLogin__bg" aria-hidden="true" />
      <main className="adminLogin__container">
        <section className="adminLogin__card" aria-label="Forgot admin password">
          <header className="adminLogin__header">
            <div className="adminLogin__badge" aria-hidden="true">
              Admin
            </div>
            <h1 className="adminLogin__title">Forgot password?</h1>
            <p className="adminLogin__subtitle">
              Enter the email for your admin account and we&apos;ll send you a reset link.
            </p>
          </header>

          {error ? (
            <div className="adminLogin__alert" role="alert">
              <span className="adminLogin__alertDot" aria-hidden="true" />
              <span>{error}</span>
            </div>
          ) : null}

          {success ? (
            <div
              className="adminLogin__alert"
              role="status"
              style={{ borderColor: 'rgba(47, 124, 255, 0.35)', background: 'rgba(47, 124, 255, 0.12)' }}
            >
              <span className="adminLogin__alertDot" aria-hidden="true" style={{ background: 'var(--al-accent)' }} />
              <span>
                Check your email for a reset link. If you don&apos;t see it, check your spam folder.
              </span>
            </div>
          ) : null}

          {!success ? (
            <form className="adminLogin__form" onSubmit={handleSubmit}>
              <label className="adminLogin__label">
                <span className="adminLogin__labelText">Email</span>
                <input
                  className="adminLogin__input"
                  type="email"
                  autoComplete="email"
                  inputMode="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  disabled={loading}
                  autoFocus
                />
              </label>

              <button className="adminLogin__submit" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <span className="adminLogin__spinner" aria-hidden="true" />
                    Sending reset link…
                  </>
                ) : (
                  'Send reset link'
                )}
              </button>
            </form>
          ) : (
            <div className="adminLogin__form">
              <RouterLink className="adminLogin__submit" to={adminPath(ADMIN_PATHS.LOGIN)} style={{ textDecoration: 'none' }}>
                Back to sign in
              </RouterLink>
            </div>
          )}

          <footer className="adminLogin__footer">
            <RouterLink className="adminLogin__secondaryLink" to={adminPath(ADMIN_PATHS.LOGIN)}>
              Back to admin sign in
            </RouterLink>
          </footer>
        </section>
      </main>
    </div>
  );
};

export default AdminForgotPasswordPage;
